// extracted by mini-css-extract-plugin
module.exports = {"subOrderContainer":"CartProductList_subOrderContainer__D3_EJ","linkContainer":"CartProductList_linkContainer__zI4AM"};